const getFixedPercentage = (number = 0, toFixed = 1) => {
  try {
    return parseFloat(number.toFixed(toFixed))
  } catch (e) {
    console.error(e)
    return number
  }
}

export default getFixedPercentage
